export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_08.f8d1d15a.png";